module.exports = __webpack_public_path__ + "img/4.b90d5400.jpg";